import { ShiftTruckCount } from 'src/graphql/types/delivery';
import { TruckCountPill } from './TruckCount';
import { formatShiftWindowLabel } from 'src/components/WarehouseOperations/shared/comparison/mapHelpers';

export const POOLED_STOPS_LABEL = 'Pooled stops';

// The key for the whole-day pool, the shift entry with a null warehouseShiftId, wherever shift entries
// are keyed by id.
export const POOLED_ID = 'pooled';

// Map a per-shift truck count to the TruckCount pill shape so the Fleet Shifts row reuses the same pill
// as the cohort row. A null warehouseShiftId is the pooled bucket ("Pooled stops"); a shift with its
// name/window is labeled from the shared formatShiftWindowLabel; a shift no longer defined on the
// warehouse (name absent) falls back to its id so its truck count is still shown, never dropped.
export const toShiftTruckCountPill = (
  entry: ShiftTruckCount,
): TruckCountPill => {
  const isPooled =
    entry.warehouseShiftId === null || entry.warehouseShiftId === undefined;
  let name: string;
  if (isPooled) {
    name = POOLED_STOPS_LABEL;
  } else if (entry.shiftType) {
    name = formatShiftWindowLabel(
      entry.shiftType,
      entry.startTime ?? '',
      entry.endTime ?? '',
    );
  } else {
    name = `Shift ${entry.warehouseShiftId}`;
  }

  // Namespace the pill id so a shift id can't collide with a cohort id in the shared
  // `truck-count-${id}` DOM namespace the cohort row also renders into.
  return {
    id: isPooled ? POOLED_ID : `shift-${entry.warehouseShiftId}`,
    name,
    truckCount: entry.truckCount,
  };
};
